import { render, staticRenderFns } from "./TicimaxMenu.vue?vue&type=template&id=5d01ed6c&scoped=true"
import script from "./TicimaxMenu.vue?vue&type=script&lang=js"
export * from "./TicimaxMenu.vue?vue&type=script&lang=js"
import style0 from "./TicimaxMenu.vue?vue&type=style&index=0&id=5d01ed6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01ed6c",
  null
  
)

export default component.exports